import Swiper from 'swiper/bundle';
import {buttonFilledSvg, buttonOutlineSvg} from "../app";

const selector = document.querySelector('.b-recipe-collection-carousel');


/**
 * Update markup with new data
 *
 * Example data:
 * {
 *          title: 'New Title',
 *          subtitle: 'New Subtitle',
 *          eyebrow: 'new EyeBrow',
 *          items: [
 * {
 * "id": 2617,
 * "link": "https://recipes2.kingsford.com/recipes/collections/30-min-meals/",
 * "name": "30 Min Meals",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/01/master-your-flavor-tile.jpg"
 * },
 * {
 * "id": 2621,
 * "link": "https://recipes2.kingsford.com/recipes/collections/big-game-eats/",
 * "name": "Big Game Eats",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/01/big-game-eats-recipe-series.jpg"
 * },
 * {
 * "id": 3329,
 * "link": "https://recipes2.kingsford.com/recipes/collections/tailgating/",
 * "name": "Easy Tailgate. Easy Win.",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/08/Char-Dogs_01b-2.jpg"
 * },
 * {
 * "id": 2622,
 * "link": "https://recipes2.kingsford.com/recipes/collections/field-to-flame/",
 * "name": "Field to Flame",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/01/field-to-flames-recipe-series.jpg"
 * },
 * {
 * "id": 2619,
 * "link": "https://recipes2.kingsford.com/recipes/collections/global-grill/",
 * "name": "Global Grill",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/01/global-grill-recipe-series.jpg"
 * },
 * {
 * "id": 3081,
 * "link": "https://recipes2.kingsford.com/recipes/collections/grilling-with-ranch/",
 * "name": "Grilling with Ranch",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/07/Title_RanchRecipes2.jpg"
 * },
 * {
 * "id": 3082,
 * "link": "https://recipes2.kingsford.com/recipes/collections/signature-flavors-series/",
 * "name": "Signature Flavors Series",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/06/Title_SigFlavorsRecipes0.jpg"
 * },
 * {
 * "id": 2620,
 * "link": "https://recipes2.kingsford.com/recipes/collections/smoke-sessions/",
 * "name": "Smoke Sessions",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/01/Smoke-sessions-video-cover.jpg"
 * },
 * {
 * "id": 2623,
 * "link": "https://recipes2.kingsford.com/recipes/collections/perfect-beef/",
 * "name": "The Perfect Beef Collection",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/01/perfect-steak-hero.png"
 * },
 * {
 * "id": 2625,
 * "link": "https://recipes2.kingsford.com/recipes/collections/pork/",
 * "name": "The Perfect Grilled Pork Collection",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/01/perfect-pork-hero.jpg"
 * },
 * {
 * "id": 2624,
 * "link": "https://recipes2.kingsford.com/recipes/collections/perfect-poultry/",
 * "name": "The Perfect Grilled Poultry Collection",
 * "image": "https://recipes2.kingsford.com/wp-content/uploads/2022/01/perfect-Chicken-hero.jpeg"
 * }
 * ],
 *     cta_text: 'CTA Text Here',
 *     cta_link: 'https://google.com/',
 * }
 *
 * @param id element to update
 * @param data replacement data
 */
function replaceRecipeCollectionCarouselData(id, data) {
    if(!id){
        console.error('No ID provided');
        return;
    }
    try {
        const { swiper } = this;
        const section = document.getElementById(id);

        /*
         * Map lytics slider data into swiper ready data, before removing all slides.
         */
        const lyticsSlider = section.querySelector('.slide--lytics-card');
        let lyticsData = null;
        if(lyticsSlider){
            lyticsData = {
                id: lyticsSlider.dataset.id,
                post_type: 'lytics',
                title: lyticsSlider.querySelector('.b-recipe-collection-carousel__recipe-card .card__inner h3').innerHTML,
                cta_text: lyticsSlider.querySelector('.b-recipe-collection-carousel__recipe-card .card__inner a span').innerHTML,
                cta_link: lyticsSlider.querySelector('.b-recipe-collection-carousel__recipe-card .card__inner a').href,
            };
        }

        /*
         * Update the main slider's section.
         */
        if(data.title && data.title !== '') {
            setTitle(section, data.title);
        }
        if (data.subtitle && data.subtitle !== '') {
            setSubtitle(section, data.subtitle);
        }
        if(data.eyebrow && data.eyebrow !== '') {
            setEyeBrow(section, data.eyebrow);
        }
        if(data.cta_link &&  data.cta_link !== '' && data.cta_text && data.cta_text !== '') {
            setCallToAction(section, { href: data.cta_link, label: data.cta_text });
        }

        /*
         * Add lyticsData to be the first slide.
         */
        if(lyticsData){
            data.items.unshift(lyticsData);
        }

        /*
         * Destroy the slider!
         */
        if(data.items && data.items.length > 0){
            swiper.removeAllSlides();
            data.items.forEach(item => {
                const slideTypes = {
                    lytics: createLyticsSlideItem,
                };
                const slideItem = slideTypes[item.post_type] ? slideTypes[item.post_type](item) : createSlideItem(item);
                if(slideItem){
                    swiper.appendSlide(slideItem);
                }
            });
            swiper.destroy();
            recipeCollectionCarousel();
        }
    } catch (e) {
        console.warn(e);
    }
}

// helper fns
const setTitle = (section, value) => {
    const element = section.querySelector('.text-group .text-group__headline .headline__text');
    if (element) {
        element.innerHTML = value;
    }
};
const setSubtitle = (section, value) => {
    const element = section.querySelector(`.text-group .text-group__paragraph .paragraph__text`);
    if (element) {
        element.innerHTML = value;
    };
};
const setEyeBrow = (section, value) => {
    const element = section.querySelector(`.text-group .text-group__eyebrow .eyebrow__text`);
    if (element) {
        element.innerHTML = value;
    }
}
const setCallToAction = (section, value) => {
    const element = section.querySelector(`.e-button`);
    if (element) {
        element.href = value.href;
        element.innerHTML = `<span class="e-button__background outline">${buttonOutlineSvg}</span>`;
        element.innerHTML += `<span class="e-button__background filled">${buttonFilledSvg}</span>`;
        element.innerHTML += `<span class="e-button__copy">${value.label}</span>`;
    }
};


/**
 * create a single slide item for Collection
 *
 * @param item data for slide
 * @returns {*} markup for slide
 */
const createSlideItem = (item) => {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');
    slide.innerHTML = `
    <div data-id="${item.id}" class="recipe-collection-carousel__collection-card c-recipe-card">
        <a href="${item.link}">
            <div class="c-recipe-card__thumbnail-wrapper">
                <div class="c-recipe-card__overlay"></div>
                <div class="c-recipe-card__no-badge"></div>
                <picture class="recipe-collection-carousel__recipe-card e-picture e-picture--4/3-ratio e-picture--rounded-none e-picture--border-none">
                    <img src="${item.image}?quality=50" alt="" height="254" width="338" />
                </picture>
            </div>

            <p class="h6 c-recipe-card__title">
                <span class="fancy-link">${item.name}</span>
            </p>
        </a>
    </div>`;

    return slide;
};

/**
 * Creates a single lytics slide.
 *
 * @param item
 */
const createLyticsSlideItem = (item) => {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide', 'slide--lytics-card');

    slide.innerHTML = `
    <div data-id="${item.id}" class="b-recipe-collection-carousel__collection-card c-recipe-card card--cta">
        <div class="c-recipe-card__thumbnail-wrapper">
            <div class="c-recipe-card__badge e-card-badge e-card-badge--primary">

            </div>
            <div class="b-recipe-collection-carousel__recipe-card">
                <div class="card__padding"></div>
                <div class="card__inner">
                    <h3>${item.title}</h3>
                    <a class="e-button e-button--primary e-button--large" href="${item.cta_link}">
                        <span class="e-button__copy">${item.cta_text}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>`;

    return slide;
};


const swiperOptions = {
    loop: false,
    slidesPerView: 1.1,
    spaceBetween: 16,
    scrollbar: {
        el: selector.querySelector('.swiper-scrollbar'),
        horizontalClass: '.swiper-kfd-scrollbar',
        draggable: true,
        dragSize: 100,
    },
    navigation: {
        nextEl: selector.querySelector('.js-carousel-next'),
        prevEl: selector.querySelector('.js-carousel-prev'),
    },
    breakpoints: {
        620: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 12,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 16,
            scrollbar: {
                dragSize: 300,
            },
        },
    },
};

// create swiper & setup replacement fn
function recipeCollectionCarousel() {
    const swiper = new Swiper(selector.querySelector('.swiper'), swiperOptions);
    window.replaceRecipeCollectionCarouselData = replaceRecipeCollectionCarouselData.bind({ swiper });
}

recipeCollectionCarousel();
